import { CHART_SEARCH_PARAM } from 'js/components/Charts/chart-search';
import { useSearchParam } from './useSearchParam';

/**
 * Hero-chart selection in the query string. Updates use history.replace so
 * switching charts does not add a history entry.
 */
export function useChartSearchParam() {
  return useSearchParam(CHART_SEARCH_PARAM);
}
